var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"info"},[_vm._v(" "+_vm._s(_vm.data.firstName)+" "+_vm._s(_vm.data.lastName)+" "),_c('br'),_vm._v(" Comisión: "+_vm._s(_vm.commissions.find((commission) => commission.id == _vm.data.commission).name)+" "),_c('br'),_vm._v(" "+_vm._s(_vm._f("dateFilter")(_vm.data.date))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }